import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "product_form" }
const _hoisted_2 = { class: "pf_materials" }
const _hoisted_3 = { class: "pf_dimensions" }
const _hoisted_4 = { class: "pf_series" }
const _hoisted_5 = { class: "pf_hidden" }
const _hoisted_6 = { class: "pf_profile_panels" }
const _hoisted_7 = { class: "pf_tracks" }

import { Product, Term, Attribute } from '@/types/product';
    import { ref, onMounted, watch, PropType, onBeforeMount } from 'vue';
    import ProductSelect from './ProductSelect.vue';
    import ProductRadio from './ProductRadio.vue';
    import CoreSelect from './attributes/CoreSelect.vue';
    import StickSelect from './attributes/StickSelect.vue';
    import useStilesService from '@/services/stiles-service';
    import StileSelect from './attributes/StileSelect.vue';
    import HeightSelect from './attributes/HeightSelect.vue';
    import WidthSelect from './attributes/WidthSelect.vue';
    import DoorPanelAdder from './attributes/DoorPanelAdder.vue';
    import getProductProperties from '@/product/getProductProperties';
    import _ from 'lodash'
    import { WebsiteItem } from '@/types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductForm',
  props: {
        product: { type: Object as PropType<Product>, required: true },
        cartItem: { type: Object as PropType<WebsiteItem|undefined>, required: false }
    },
  emits: ['productUpdate'],
  setup(__props, { emit: emits }) {

const props = __props

    
    
    const productSelections = ref<Record<string, Term | null>>({})
    const stileService = useStilesService()
    const attributeImageOverrides = ref<{[key: string]: {url: string, attributeEquality: {[key: string]: string}}[]}>({})

    watch(productSelections.value, () => {
        calculateAttributeImageOverrides()
    })

    watch(productSelections.value, _.debounce((current, old) => {
        const properties = getProductProperties(props.product, productSelections.value)
        emits('productUpdate', properties)
    },300))
    
    function displayStiles() {
        if(props.product) {
            const bdt = props.product.attributes['base-door']?.terms[0].name || null
            return (bdt) ? stileService.doesProductHaveStiles(props.product.name, bdt) : false
        } else {
            return false
        }
    }

    onBeforeMount(async () => {
        setDefaultProductSelections()
    })

    function setDefaultProductSelections() {
        const attributes: Attribute[] = Object.values(props.product.attributes)

        attributes.forEach(attr => {
            const { name, terms } = attr
            // series_note will be generated from series term.description so need to skip
            if(name !== "series-note") {
                if(props.cartItem) {
                    productSelections.value[name] = findCartItemSelection(name, terms)
                }
                if(!productSelections.value[name]) {
                    if(name == 'glass') {
                        productSelections.value['glass'] = terms.find(o => o.slug === 'clear' || o.slug === 'clear-18') || terms[0]
                    } else if(name == 'width') {
                        productSelections.value['width'] = terms.find(o => o.slug === '30') || terms[0]
                    } else {
                        productSelections.value[name] = terms[0]
                    }
                }
            }
        })
        if(displayStiles()) {
            productSelections.value['stile'] = findCartItemSelection('stile',[])
        }
    }

    function findCartItemSelection(attr: string, terms: Term[]) {
        let term: Term | null = null
        if(attr == 'width') {
            if(props.cartItem?.custom_width) {
                term = {
                    id: 999999,
                    name: props.cartItem?.custom_width_text || '',
                    slug: props.cartItem?.custom_width.toString()
                }
            }
        } else if(attr == 'height') {
            if(props.cartItem?.custom_height) {
                term = {
                    id: 999999,
                    name: props.cartItem?.custom_height_text || '',
                    slug: props.cartItem?.custom_height.toString()
                }
            }
        } else if(attr == 'stile') {
            if(props.cartItem?.custom_stile_value) {
                term = {
                    id: props.cartItem?.custom_stile_id,
                    name: props.cartItem?.stile_text || props.cartItem?.custom_stile_value.toString(),
                    slug: props.cartItem?.stile || props.cartItem?.custom_stile_value.toString()
                }
            }
        }

        if(!term) {
            if(props.cartItem) {
                const attrName = attr.replaceAll('-','_')
                const matchId = parseInt((props.cartItem as any)[attrName])
                term = terms.find(o => o.id == matchId) || null
            }
        }

        return term
    }

    function calculateAttributeImageOverrides() {
        if (!props.product) return
        attributeImageOverrides.value = {}
        for (const override of props.product.attribute_image_overrides) {
            const attributeMatches = _.isMatch(productSelections.value, override.conditions.equals)
            if (attributeMatches) {
                attributeImageOverrides.value[override.attribute] = attributeImageOverrides.value[override.attribute] || []
                attributeImageOverrides.value[override.attribute].push({url: override.imageUrl, attributeEquality: override.attributeEquality})
            }
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.product.attributes.material)
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.product.attributes.material, {
            modelValue: productSelections.value['material'],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((productSelections.value['material']) = $event)),
            "use-image": true
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes.glass)
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 1 }, props.product.attributes.glass, {
            modelValue: productSelections.value['glass'],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((productSelections.value['glass']) = $event)),
            "use-image": true
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (props.product.attributes.thickness)
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.product.attributes.thickness, {
            modelValue: productSelections.value['thickness'],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((productSelections.value['thickness']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes.height)
        ? (_openBlock(), _createBlock(HeightSelect, {
            key: 1,
            modelValue: productSelections.value['height'],
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((productSelections.value['height']) = $event)),
            attribute: props.product.attributes.height,
            "product-name": props.product.name
          }, null, 8, ["modelValue", "attribute", "product-name"]))
        : _createCommentVNode("", true),
      (props.product.attributes.width)
        ? (_openBlock(), _createBlock(WidthSelect, {
            key: 2,
            modelValue: productSelections.value['width'],
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((productSelections.value['width']) = $event)),
            attribute: props.product.attributes.width,
            "product-name": props.product.name
          }, null, 8, ["modelValue", "attribute", "product-name"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({'pf_series_plus_options': __props.product.attributes.series})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({'pf_core_stile_stick': !__props.product.attributes.series})
      }, [
        (props.product.attributes.edge)
          ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.product.attributes.edge, {
              modelValue: productSelections.value['edge'],
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((productSelections.value['edge']) = $event))
            }), null, 16, ["modelValue"]))
          : _createCommentVNode("", true),
        (props.product.attributes.core)
          ? (_openBlock(), _createBlock(CoreSelect, {
              key: 1,
              attribute: props.product.attributes.core,
              modelValue: productSelections.value['core'],
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((productSelections.value['core']) = $event)),
              width: productSelections.value['width'],
              series: productSelections.value['series']
            }, null, 8, ["attribute", "modelValue", "width", "series"]))
          : _createCommentVNode("", true),
        (displayStiles())
          ? (_openBlock(), _createBlock(StileSelect, {
              key: 2,
              modelValue: productSelections.value['stile'],
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((productSelections.value['stile']) = $event)),
              width: productSelections.value['width'],
              series: productSelections.value['series']
            }, null, 8, ["modelValue", "width", "series"]))
          : _createCommentVNode("", true),
        (props.product.attributes.stick)
          ? (_openBlock(), _createBlock(StickSelect, {
              key: 3,
              attribute: props.product.attributes.stick,
              modelValue: productSelections.value['stick'],
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((productSelections.value['stick']) = $event)),
              series: productSelections.value['series']
            }, null, 8, ["attribute", "modelValue", "series"]))
          : _createCommentVNode("", true),
        (props.product.attributes['unit-option'])
          ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 4 }, props.product.attributes['unit-option'], {
              modelValue: productSelections.value['unit-option'],
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((productSelections.value['unit-option']) = $event))
            }), null, 16, ["modelValue"]))
          : _createCommentVNode("", true),
        (props.product.attributes['insulating-type'])
          ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 5 }, props.product.attributes['insulating-type'], {
              modelValue: productSelections.value['insulating-type'],
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((productSelections.value['insulating-type']) = $event))
            }), null, 16, ["modelValue"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        (props.product.attributes.series)
          ? (_openBlock(), _createBlock(ProductRadio, _mergeProps({ key: 0 }, props.product.attributes.series, {
              modelValue: productSelections.value['series'],
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((productSelections.value['series']) = $event))
            }), null, 16, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      (props.product.attributes['panel-type'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.product.attributes['panel-type'], {
            modelValue: productSelections.value['panel-type'],
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((productSelections.value['panel-type']) = $event)),
            class: {'hidden':true}
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['door-config'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 1 }, props.product.attributes['door-config'], {
            modelValue: productSelections.value['door-config'],
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((productSelections.value['door-config']) = $event)),
            class: {'hidden':true}
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['base-door'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 2 }, props.product.attributes['base-door'], {
            modelValue: productSelections.value['base-door'],
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((productSelections.value['base-door']) = $event)),
            class: {'hidden':true}
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['door-type'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 3 }, props.product.attributes['door-type'], {
            modelValue: productSelections.value['door-type'],
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((productSelections.value['door-type']) = $event)),
            class: {'hidden':true}
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['not-priceable'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 4 }, props.product.attributes['not-priceable'], {
            modelValue: productSelections.value['not-priceable'],
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((productSelections.value['not-priceable']) = $event)),
            class: {'hidden':true}
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (props.product.attributes['door-profile'])
        ? (_openBlock(), _createBlock(ProductRadio, _mergeProps({ key: 0 }, props.product.attributes['door-profile'], {
            modelValue: productSelections.value['door-profile'],
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((productSelections.value['door-profile']) = $event)),
            "image-overrides": attributeImageOverrides.value['door-profile']
          }), null, 16, ["modelValue", "image-overrides"]))
        : _createCommentVNode("", true),
      (props.product.attributes['door-panel-type'])
        ? (_openBlock(), _createBlock(ProductRadio, _mergeProps({ key: 1 }, props.product.attributes['door-panel-type'], {
            modelValue: productSelections.value['door-panel-type'],
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((productSelections.value['door-panel-type']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['door-panel-adder'])
        ? (_openBlock(), _createBlock(DoorPanelAdder, {
            key: 2,
            attribute: props.product.attributes['door-panel-adder'],
            modelValue: productSelections.value['door-panel-adder'],
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((productSelections.value['door-panel-adder']) = $event)),
            "door-panel-type": productSelections.value['door-panel-type']
          }, null, 8, ["attribute", "modelValue", "door-panel-type"]))
        : _createCommentVNode("", true),
      (props.product.attributes['louver-profile'])
        ? (_openBlock(), _createBlock(ProductRadio, _mergeProps({ key: 3 }, props.product.attributes['louver-profile'], {
            modelValue: productSelections.value['louver-profile'],
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((productSelections.value['louver-profile']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (props.product.attributes['track-type'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 0 }, props.product.attributes['track-type'], {
            modelValue: productSelections.value['track-type'],
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((productSelections.value['track-type']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['track-color'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 1 }, props.product.attributes['track-color'], {
            modelValue: productSelections.value['track-color'],
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((productSelections.value['track-color']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true),
      (props.product.attributes['track-size'])
        ? (_openBlock(), _createBlock(ProductSelect, _mergeProps({ key: 2 }, props.product.attributes['track-size'], {
            modelValue: productSelections.value['track-size'],
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((productSelections.value['track-size']) = $event))
          }), null, 16, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})